import React, {useState} from 'react';
import {Grid, Card, CardHeader, CardContent, Tabs, Tab} from '@material-ui/core';
import SenhasComponent from '../pages/Tabnations/SenhasComponent';
import AtenderPacienteComponent from '../pages/Tabnations/AtenderPacienteComponent';


const Main = ({children}) => {
    const [open, setOpen] = useState(false);
    const [value, setValue] = useState(0);
    const [activeTab, setActiveTab] = useState(0);

    const handleChangeTab = (event, newValue) => {
        setValue(newValue);
        setActiveTab(newValue);
    };

    return (
        <main style={{marginLeft: "250px", padding: "20px",}}>
            {children}
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Card style={{height: '90vh', overflow: "auto"}}>
                        <CardContent className={"card-triagem"}>
                            <Grid
                                container
                                spacing={3}
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "baseline",
                                }}
                            >
                                <Grid item>
                                    <CardHeader title="Painel de triagem"/>
                                </Grid>
                            </Grid>
                            <div>
                                <Tabs
                                    value={value}
                                    onChange={handleChangeTab}
                                    style={{
                                        backgroundColor: "rgba(255,255,255,0.5)",
                                    }}
                                >
                                    <Tab
                                        label="SENHAS"
                                        style={{
                                            color: activeTab === 0 ? "rgba(0,0,0,0.9)" : "black",
                                            backgroundColor:
                                                activeTab === 0
                                                    ? "#f1f4ff"
                                                    : "rgba(0,0,0,0)",
                                        }}/>
                                    <Tab
                                        label="ENCAMINHAR PACIENTE"
                                        style={{
                                            color: activeTab === 0 ? "rgba(0,0,0,0.9)" : "black",
                                            backgroundColor:
                                                activeTab === 0
                                                    ? "#f1f4ff"
                                                    : "rgba(0,0,0,0)",
                                        }}/>
                                </Tabs>
                                {activeTab === 0 && <SenhasComponent/>}
                                {activeTab === 1 && <AtenderPacienteComponent/>}
                            </div>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </main>
    );
};

export default Main;
